(function () {
  console.log('[SupplierStock] Script loaded');

  function isSupplierProduct() {
    const badge = document.querySelector('.js-stock-text');
    console.log('[SupplierStock] Badge element:', badge);
    console.log('[SupplierStock] Badge text:', badge ? badge.textContent.trim() : 'NOT FOUND');
    return badge && badge.textContent.trim() === 'Stoc furnizor';
  }

  function reset() {
    console.log('[SupplierStock] reset() called — restoring normal state');

    const buyNowBtn = document.querySelector('.product-actions-buy-now');
    if (buyNowBtn) {
      buyNowBtn.style.display = '';
      console.log('[SupplierStock] Buy now button restored');
    }

    const addToCartBtn = document.querySelector('button[name="add"]');
    if (addToCartBtn) {
      const span = addToCartBtn.querySelector('span');
      if (span) {
        console.log('[SupplierStock] Add to cart span found, not modifying (reset)');
      }
    }

    const notice = document.querySelector('.supplier-stock-notice');
    if (notice) {
      notice.remove();
      console.log('[SupplierStock] Notice removed');
    }
  }

  function apply() {
    console.log('[SupplierStock] apply() called — this is a supplier product');

    const addToCartBtn = document.querySelector('button[name="add"]');
    if (addToCartBtn) {
      const span = addToCartBtn.querySelector('span');
      if (span) {
        console.log('[SupplierStock] Add to cart span text before:', span.textContent);
        span.textContent = 'Precomanda';
        console.log('[SupplierStock] Add to cart span text after:', span.textContent);
      } else {
        console.warn('[SupplierStock] Add to cart button found but no span inside');
      }
    } else {
      console.warn('[SupplierStock] Add to cart button NOT found (button[name="add"])');
    }

    const buyNowBtn = document.querySelector('.product-actions-buy-now');
    if (buyNowBtn) {
      buyNowBtn.style.display = 'none';
      console.log('[SupplierStock] Buy now button hidden');
    } else {
      console.warn('[SupplierStock] Buy now button NOT found (.product-actions-buy-now)');
    }

    if (!document.querySelector('.supplier-stock-notice')) {
      const productActions = document.querySelector('.product-actions');
      if (productActions) {
        const notice = document.createElement('p');
        notice.className = 'supplier-stock-notice';
        notice.textContent = 'Produs disponibil din stocul furnizorului — livrare estimata in aproximativ 3 saptamani.';
        productActions.insertAdjacentElement('afterend', notice);
        console.log('[SupplierStock] Notice injected after .product-actions');
      } else {
        console.warn('[SupplierStock] .product-actions NOT found — notice not injected');
      }
    } else {
      console.log('[SupplierStock] Notice already exists, skipping');
    }
  }

  function check() {
    console.log('[SupplierStock] check() called');
    if (isSupplierProduct()) {
      apply();
    } else {
      console.log('[SupplierStock] Not a supplier product — calling reset()');
      reset();
    }
  }

  function injectStyles() {
    if (document.querySelector('#supplier-stock-styles')) {
      console.log('[SupplierStock] Styles already injected, skipping');
      return;
    }
    const style = document.createElement('style');
    style.id = 'supplier-stock-styles';
    style.textContent = `
      .supplier-stock-notice {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 1.2rem;
        font-weight: 600;
        color: #92400e;
        margin-top: 14px;
        padding: 14px 18px;
        background: #fef3c7;
        border-radius: 8px;
        border: 1px solid #f59e0b;
        line-height: 1.5;
      }

      .product-info .badge-backorder,
      .product-info-meta .badge-backorder {
        background-color: #eff6ff;
        color: #1d4ed8;
        border: 1px solid #bfdbfe;
      }

      .product-info .badge-backorder .badge-stock-dot,
      .product-info-meta .badge-backorder .badge-stock-dot {
        background-color: #1d4ed8;
      }
    `;
    document.head.appendChild(style);
    console.log('[SupplierStock] Styles injected');
  }

  function init() {
    console.log('[SupplierStock] init() called');
    injectStyles();
    check();

    const badgeContainer = document.querySelector('.product-info-meta');
    if (badgeContainer) {
      console.log('[SupplierStock] MutationObserver attached to .product-info-meta');
      const observer = new MutationObserver(function () {
        console.log('[SupplierStock] DOM mutation detected in badge container');
        check();
      });
      observer.observe(badgeContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    } else {
      console.warn('[SupplierStock] .product-info-meta NOT found — MutationObserver not attached');
    }
  }

  if (document.readyState === 'loading') {
    console.log('[SupplierStock] DOM not ready, waiting for DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', init);
  } else {
    console.log('[SupplierStock] DOM already ready, running init() immediately');
    init();
  }

})();